import { render, staticRenderFns } from "./SmsPreview.vue?vue&type=template&id=c126374c&scoped=true"
import script from "./SmsPreview.vue?vue&type=script&lang=js"
export * from "./SmsPreview.vue?vue&type=script&lang=js"
import style0 from "./SmsPreview.vue?vue&type=style&index=0&id=c126374c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c126374c",
  null
  
)

export default component.exports